import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';

import {useGetSessionUser} from '../../../core/use-get-session-user';

import {appHistory} from '../../../../history';

import styles from './analytics-empty-state.module.css';

export function AnalyticsEmptyState() {
    const {user} = useGetSessionUser();
    const canAccessSetup = user && user.permissions.canAccessSetup;

    return (
        <div className={styles.container}>
            <EmptyStateLarge
                title='Try Nutshell Analytics to learn about your site visitors'
                subtitle='Learn more about the people, companies, and leads who submit a
                        form on your website'
                detailTextBullets={[
                    <>
                        Set up tracking by embedding a small snippet of code on your website (if
                        it’s built with WordPress, you can try our{' '}
                        <Link
                            variant='primary'
                            href='https://wordpress.org/plugins/nutshell-analytics/#description'
                            newTab={true}
                            size='big'
                        >
                            plugin
                        </Link>
                        )
                    </>,
                    'Learn more about site visitors when they submit a form, like which channel they came from and what pages they visited',
                    'Use this source data to understand where your leads come from and help your team make the right sales and marketing decisions',
                ]}
                icon={<Illustration src='code-snippet' />}
                cta={
                    <Link
                        variant='button-secondary'
                        href='https://support.nutshell.com/en/articles/8429026-nutshell-analytics-tracking-website-visitors'
                        newTab={true}
                        size='xlarge'
                    >
                        Learn more
                    </Link>
                }
                secondaryCta={
                    canAccessSetup && (
                        <Button
                            variant='primary'
                            size='xlarge'
                            onClick={() => appHistory.push('/setup/tracking-snippet')}
                        >
                            Configure your website
                        </Button>
                    )
                }
            />
        </div>
    );
}
